import React from "react";
//import { View, StyleSheet } from "react-native";
import { View, StyleSheet, TouchableOpacity, Text } from "react-native";
import { Option, Title, InputBox } from "../../accessories/accessories";
import Dropdown from "../../accessories/DropDown";
import { web, android, ios } from "../../accessories/Platform";
import { cleanValue, log } from "../../accessories/CommonFunctions";
import AddressAutocomplete from "../../accessories/GooglePlacesAutoComplete";
import AddressAutocompleteApp from "../../accessories/GooglePlacesAutoCompleteApp";

const AddressHistory = ({ detailsArr, handleOptionPress, LockLoanApp }) => {
  let typeTwoFields = null;

  try {
    detailsArr["subFields"] = detailsArr["subFields"]?.filter(
      (e) => e !== null
    );
    typeTwoFields =
      detailsArr["subFields"]?.length > 0 ? detailsArr["subFields"] : [];
  } catch (error) {}
  return (
    <View>
      <Title text={detailsArr["Title"]} />

      {typeTwoFields?.length > 0 && (
        <>
          {detailsArr["headerContent"] && (
            <>
              <Title
                text={detailsArr["headerContent"]["Title"]}
                style={{ marginTop: -10 }}
              />
              <View
                style={
                  detailsArr["headerContent"]["widthOption"] !== undefined
                    ? {
                        flexDirection: "row",
                        justifyContent: "space-around",
                        marginTop: -10,
                      }
                    : { flex: 1 }
                }
              >
                {detailsArr["headerContent"]["Options"]?.map((item, index) => (
                  <Option
                    key={index}
                    style={
                      detailsArr["headerContent"]["widthOption"] !== undefined
                        ? { width: detailsArr["headerContent"]["widthOption"] }
                        : {}
                    }
                    text={item["text"]}
                    value={
                      item["value"] ===
                      detailsArr["headerContent"]["ColumnValue"]
                    }
                    onPress={() =>
                      detailsArr["handleCopyPriAddress"](
                        detailsArr["index"],
                        detailsArr["headerContent"]["ColumnName"],
                        item["value"]
                      )
                    }
                  />
                ))}
              </View>
            </>
          )}
          <View>
            {typeTwoFields?.map((item, index) => (
              <View key={index}>
                <Title text={item["Title"]} />
                <>
                  {item["type"] === 3 ? (
                    <>
                      <Dropdown
                        isValid={item["isValid"]}
                        label={item["label"]}
                        options={item["Option"]}
                        value={
                          item["isMap"]
                            ? item["Option"].filter(
                                (e) => e["value"] == item["ColumnValue"]
                              )[0]?.label
                            : item["ColumnValue"]
                        }
                        onSelect={(item_) => {
                          detailsArr["onTextChange"] !== undefined
                            ? detailsArr["onTextChange"](
                                detailsArr["index"],
                                item["ColumnName"],
                                item_["value"]
                              )
                            : handleOptionPress(
                                item_["value"],
                                null,
                                null,
                                item["ColumnName"]
                              );
                        }}
                        placeholder={item["placeholder"] || ""}
                        isMap={item["isMap"]}
                      />
                    </>
                  ) : item["type"] === 4 && item["isAddressAutocomplete"] ? (
                    android || ios ? (
                       
                      <AddressAutocompleteApp
                        label={item["label"]}
                        value={item["ColumnValue"]?.toString() || ""}
                        placeholder={item["placeholder"] || item["label"]}
                        validate={item["isValid"]}
                        forceValidation={item["forceValidation"]}
                        onChange={(text) => {
                          handleOptionPress(
                            text,
                            true,
                            index,
                            item["ColumnName"]
                          );
                        }}
                        onAddressSelect={item["onAddressSelect"]}
                        onBlur={() =>
                          item["onBlur"] !== undefined
                            ? item["onBlur"]()
                            : () => {}
                        }
                        disabled={LockLoanApp == 1}
                      />
                    ) : (
                      <AddressAutocomplete
                        label={item["label"]}
                        value={item["ColumnValue"]?.toString() || ""}
                        placeholder={item["placeholder"] || item["label"]}
                        validate={item["isValid"]}
                        forceValidation={item["forceValidation"]}
                        onChange={(text) => {
                          handleOptionPress(
                            text,
                            true,
                            index,
                            item["ColumnName"]
                          );
                        }}
                        onAddressSelect={item["onAddressSelect"]}
                        onBlur={() =>
                          item["onBlur"] !== undefined
                            ? item["onBlur"]()
                            : () => {}
                        }
                        disabled={LockLoanApp == 1}
                      />
                    )
                  ) : (
                    <InputBox
                      keyboardType={item["keyboardType"]}
                      formatZero={item["formatZero"]}
                      maxLength={item["maxLength"]}
                      isCurrency={item["isCurrency"]}
                      forceValidation={item["forceValidation"]}
                      validate={item["isValid"] || false}
                      label={item["label"]}
                      placeholder={item["placeholder"] || item["label"]}
                      onBlur={(text) =>
                        item["onBlur"] !== undefined
                          ? item["onBlur"]()
                          : () => {}
                      }
                      onChangeText={(text) => {
                        try {
                          if (item["keyboardType"]) {
                            text = text.replace(/[^0-9]/g, "");
                            if (text == "") text = 0;
                          }

                          if (item["ColumnName"] == "Addrshistry_Months") {
                            if (/^(0?[1-9]|1[0-2])$/.test(text) == false) {
                              text = 0;
                            }
                          }
                          detailsArr["onTextChange"] !== undefined
                            ? detailsArr["onTextChange"](
                                detailsArr["index"],
                                item["ColumnName"],
                                text,
                                null,
                                item["label"],
                                detailsArr["isCheckAddMonthCount"]
                              )
                            : handleOptionPress(
                                text,
                                true,
                                index,
                                item["ColumnName"]
                              );
                        } catch (e) {
                          log("Error from onTextChange ====> ", e);
                        }
                      }}
                      value={item["ColumnValue"]?.toString()}
                    />
                  )}
                </>
              </View>
            ))}
          </View>
        </>
      )}
      {detailsArr["footerContent"] && (
        <>
          <Title text={detailsArr["footerContent"]["Title"]} />
          <View style={{ flex: 1 }}>
            {detailsArr["footerContent"]["Options"]?.map((item, index) => (
              <Option
                key={index}
                text={item["text"]}
                value={
                  item["value"] === detailsArr["footerContent"]["ColumnValue"]
                }
                onPress={() => {
                  try {
                    detailsArr["onTextChange"] !== undefined
                      ? detailsArr["onTextChange"](
                          detailsArr["index"],
                          detailsArr["footerContent"]["ColumnName"],
                          item["value"],
                          null,
                          null,
                          null,
                          detailsArr["prevAddIndex"]
                        )
                      : handleOptionPress(
                          item["value"],
                          null,
                          null,
                          item["ColumnName"],
                          detailsArr["index"] || -1
                        );
                  } catch (e) {
                    console.log("Error from ====>", e);
                  }
                }}
              />
            ))}
          </View>
          {detailsArr["footerContent"].subFields && (
            <>
              {Object.keys(detailsArr["footerContent"]["subFields"]).length >
                0 && (
                <InputBox
                  keyboardType={
                    detailsArr["footerContent"]["subFields"]["keyboardType"]
                  }
                  maxLength={
                    detailsArr["footerContent"]["subFields"]["maxLength"]
                  }
                  isCurrency={
                    detailsArr["footerContent"]["subFields"]["isCurrency"]
                  }
                  validate={
                    detailsArr["footerContent"]["subFields"]["isValid"] || false
                  }
                  label={detailsArr["footerContent"]["subFields"]["label"]}
                  placeholder={
                    detailsArr["footerContent"]["subFields"]["placeholder"] ||
                    detailsArr["footerContent"]["subFields"]["label"]
                  }
                  onBlur={() =>
                    detailsArr["footerContent"]["subFields"]["onBlur"] !==
                    undefined
                      ? detailsArr["footerContent"]["subFields"]["onBlur"]()
                      : () => {}
                  }
                  onFocus={(event) => {
                    let val =
                        detailsArr["footerContent"]["subFields"]["ColumnValue"],
                      text =
                        cleanValue(val) == 0
                          ? ""
                          : val?.toString()?.replaceAll("$", "");
                    detailsArr["onTextChange"] !== undefined
                      ? detailsArr["onTextChange"](
                          detailsArr["index"],
                          detailsArr["footerContent"]["subFields"][
                            "ColumnName"
                          ],
                          text
                        )
                      : handleOptionPress(
                          text,
                          true,
                          detailsArr["index"],
                          detailsArr["footerContent"]["subFields"]["ColumnName"]
                        );
                  }}
                  onChangeText={(text) => {
                    try {
                      detailsArr["onTextChange"] !== undefined
                        ? detailsArr["onTextChange"](
                            detailsArr["index"],
                            detailsArr["footerContent"]["subFields"][
                              "ColumnName"
                            ],
                            text
                          )
                        : handleOptionPress(
                            text,
                            true,
                            detailsArr["index"],
                            detailsArr["footerContent"]["subFields"][
                              "ColumnName"
                            ]
                          );
                    } catch (e) {
                      log("Error from onTextChange ====> ", e);
                    }
                  }}
                  value={detailsArr["footerContent"]["subFields"][
                    "ColumnValue"
                  ]?.toString()}
                />
              )}
            </>
          )}
        </>
      )}
      {detailsArr["showSkipButton"] && (
        <TouchableOpacity
          style={{
            backgroundColor: "#1a63ad",
            borderRadius: 25,
            paddingVertical: 12,
            paddingHorizontal: 20,
            marginTop: 20,
            marginBottom: 10,
            alignSelf: "center",
          }}
          onPress={detailsArr["onSkipPress"]}
          disabled={LockLoanApp == 1}
        >
          <Text style={{ color: "#fff", fontSize: 16, fontWeight: "600" }}>
            Skip to Next Page
          </Text>
        </TouchableOpacity>
      )}
      {detailsArr["footerContent"]["footerButton"] &&
        detailsArr["footerContent"]["footerButton"]}
    </View>
  );
};

const styles = StyleSheet.create({
  inputBoxContainer: {
    flexDirection: "row",
    borderColor: "gray",
    borderWidth: 1,
    borderRadius: 8,
    padding: 10,
    marginBottom: 20,
  },
  iconButtonContainer: {
    backgroundColor: "#1a63ad",
    borderRadius: 25,
    height: 45,
    paddingVertical: 10,
    paddingHorizontal: 10,
    marginTop: 8,
    paddingTop: web ? "5px" : null,
    alignSelf: "flex-start",
    padding: 30,
  },
  iconButtonText: {
    fontSize: 18,
    color: "#fff",
  },
  inputBoxLabel: {
    position: "absolute",
    backgroundColor: "#fff",
    top: -12,
    left: 3,
    fontSize: 14,
    color: "gray",
    paddingHorizontal: 3,
  },
  inputBox: {
    ...{
      borderWidth: 0,
      borderRadius: 5,
      fontSize: web ? 15 : 16,
      backgroundColor: "rgba(0,0,0,.04)",
      color: "#51575d",
      width: "100%",
      padding: 5,
    },
  },
});

export default AddressHistory;
